import { render, staticRenderFns } from "./SignUpDetailWebmaster.vue?vue&type=template&id=2bdae1f1&scoped=true"
import script from "./SignUpDetailWebmaster.vue?vue&type=script&lang=js"
export * from "./SignUpDetailWebmaster.vue?vue&type=script&lang=js"
import style0 from "./SignUpDetailWebmaster.vue?vue&type=style&index=0&id=2bdae1f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdae1f1",
  null
  
)

export default component.exports